module.exports = __webpack_public_path__ + "static/media/Lexington-condominium_bylaws.52eb0184.pdf";